import type { UseQueryResult } from "@tanstack/react-query";

export function mergedStatus(
  queries: UseQueryResult[]
): Pick<UseQueryResult, "status" | "isPending" | "isError" | "isSuccess"> {
  const isSuccess = queries.every((q) => {
    return q.isSuccess;
  });

  const isError = queries.some((q) => q.isError);
  const isPending = queries.some((q) => q.isPending);
  const status = isError ? "error" : isPending ? "pending" : "success";
  return {
    isSuccess,
    isError,
    isPending,
    status
  };
}
